<template>
	<component :is="dynamicComponent" :href="(this.settings.link?this.settings.link:null)">
		<div class="block clearfix">
			<div
				style="position: relative; width: 88px; height: 88px; display: block; float: left"
				class="mr-3"
			>
				<template v-if="settings.ready">
					<RadialProgressBar
						:diameter="88"
						:totalSteps="this.maxAmount"
						:completedSteps="this.settings.value"
						:startColor="getRingColor()"
						:stopColor="getRingColor()"
						:animateSpeed="1000"
						:isClockwise="true"
						timingFunc="ease-out"
						innerStrokeColor="#E5E7EB"
						class="float-left"
						style="position: absolute"
					/>
					<div
						style="
							position: absolute;
							top: 50%;
							left: 50%;
							transform: translateY(-50%) translateX(-50%);
						"
					>
						<ICountUp :delay="0" :endVal="settings.value" :options="options" />
						<span>{{ this.settings.percentage ? "%" : this.settings.target ? "/" + this.settings.target : '' }}</span>
					</div>
				</template>
				<template v-else>
					<div class="skeleton muted" style="border-radius: 88px; width: 80px; height: 80px; background-color: #E5E7EB"></div>
				</template>
			</div>
			<div style="float: left">
				<p class="mb-1 mt-3 font-bold">{{ this.settings.caption }}</p>
				<LabelIndicator v-if="(this.settings.pass)" :type="this.settings.pass==true ? 'success' : 'danger'">
					{{ this.settings.pass==true ? $t('pass') : $t('fail') }}
				</LabelIndicator>
			</div>
		</div>
	</component>
</template>

<script>
import RadialProgressBar from "vue-radial-progress";
import ICountUp from "vue-countup-v2";
import LabelIndicator from "../LabelIndicator";

export default {
	name: "RadialGraph",
	props: {
		settings: Object,
		options: Object
	},
	data() {
		return {
			completedSteps: 0,
			value: 0,
		};
	},
	components: {
		RadialProgressBar,
		LabelIndicator,
		ICountUp,
	},
	mounted() {
	},
	watch: {
		/*
		settings: function () {
			if(this.settings.ready) {
				alert('here');
				this.completedSteps = this.value;
				//this.value = Number(this.percentage) || Number(this.position);
			}
		}
		*/
	},
	computed: {
		maxAmount() {
			if('percentage' in this.settings){
				return 100;
			}
			if ('max' in this.settings) {
				return Number(this.settings.max);
			}
			//return 100;
			if (this.settings.target) {
				if (Number(this.settings.target) > Number(this.settings.value)) {
					return Number(this.settings.target);
				}
			}
			if(this.settings.showquartiles && this.settings.quartiles) {
				return Number(this.settings.quartiles[4]);
			}
			if (this.settings.median) {
				var max = Number(this.settings.median) * 2;
				if (max > Number(this.settings.value)) {
					return max;
				}
			}
			if (this.settings.quartiles) {
				return Number(this.settings.quartiles[4]);
			}
			return Number(this.settings.value) || 1;
		},
		progressClass() {
			var cssclass = 'mb-3 w-full';
			if(!('ready' in this.settings) || !this.settings.ready){
				cssclass += ' skeleton';
			}
			if (this.reversed) {
				cssclass += ' justify-content-end';
			}
			return cssclass;
		},
		variant() {
			var value = Number(this.settings.value);
			var breakpoints = [];
			if('percentage' in this.settings){
				breakpoints = [
					0 ,
					40 ,
					60 ,
					80
				];
			} else if (this.settings.target) {
				breakpoints = [
					0 ,
					Number(this.settings.target) * .5 ,
					Number(this.settings.target) * .75 ,
					Number(this.settings.target)
				];
			}
			else if (this.settings.showquartiles && this.settings.quartiles) {
				breakpoints = this.settings.quartiles
			}
			else if (Number(this.settings.median)){
				var max = Number(this.settings.median);
				breakpoints = [
					0 ,
					Number(max) * .25 ,
					Number(max) * .5 ,
					Number(max) * .75
				];
			}
			else if (this.settings.quartiles) {
				breakpoints = this.settings.quartiles
			}

			if(value >= breakpoints[3]){
				return "fourth-quartile";
			}
			if(value >= breakpoints[2]){
				return "third-quartile";
			}
			if(value >= breakpoints[1]){
				return "second-quartile";
			}
			return "first-quartile";

		},
		amountClass() {
			return `text-${this.variant} font-bold`;
		},
		dynamicComponent() {
			if (this.link) {
				return "a";
			}
			return "div";
		},
		completedAmount() {
			if ('value' in this.settings) {
				return Number(this.settings.value);
			}
			if('percentage' in this.settings){
				return Number(this.settings.percentage);
			}
			return 0;
		},
	},
	methods: {
		getRingColor() {
			var variant = this.variant;

			if(variant == 'fourth-quartile'){
				return "#4ade80";
			}
			if(variant == 'third-quartile'){
				return "#facc15";
			}
			if(variant == 'second-quartile'){
				return "#fb923c";
			}
			return "#F87171";
		},
	},
};
</script>
